module.exports = __webpack_public_path__ + "static/media/Logo.c5eb011a.svg";